import { useEffect } from "react";
import { useAppStore } from "@/state/appStore";

export const useTheme = (): void => {
  const theme = useAppStore((state) => state.theme);

  useEffect(() => {
    const root = document.documentElement;
    const media = window.matchMedia("(prefers-color-scheme: dark)");
    const apply = () => {
      if (theme === "system") {
        root.setAttribute("data-theme", media.matches ? "dark" : "light");
        return;
      }
      root.setAttribute("data-theme", theme);
    };
    apply();
    if (theme !== "system") return;
    const onChange = () => apply();
    media.addEventListener("change", onChange);
    return () => {
      media.removeEventListener("change", onChange);
    };
  }, [theme]);
};
